// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3dc05e66","488":"a14021bf","977":"0422e927"}[chunkId] + ".chunk.js";
};